import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LetterSurveyButtonComponent } from './letter-survey-button.component';

@NgModule({
  declarations: [LetterSurveyButtonComponent],
  imports: [
    CommonModule,
  ],
  exports: [
    CommonModule,
    LetterSurveyButtonComponent,
  ],
})
export class LetterSurveyButtonModule { }
